const BASE_URL = 'https://api.olaitools.com/api';


export const fetchQuestionAverageByStudent = async (start, end, courseId) => {
    console.log("overviewApi - fetchQuestionAverageByStudent - start, end, courseId:", start, end, courseId);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-average-by-student`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-average-by-student`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch question average by student');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching question average by student:", error);
        throw error;
    }
};
export const fetchDemoQuestionAverageByStudent = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-question-average-by-student${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo question average by student');
        }
        const data = await response.json();
        console.log("Demo question avg by student", data) // - confirmed
        return data;
    } catch (error) {
        console.error("Error fetching demo question average by student:", error);
        throw error;
    }
};

export const fetchClickSequenceByStudent = async (start, end, courseId) => {
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/click-sequence-by-student-course`;
        } else {
            endpoint = `${BASE_URL}/dashboard/click-sequence-by-student`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch click sequence by student');
        }

        const data = await response.json();
        console.log("individual click sequence API", data);
        return data;
    } catch (error) {
        console.error("Error fetching click sequence by student:", error);
        throw error;
    }
};
export const fetchDemoClickSequenceByStudent = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/click-sequence-by-student${query}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo click sequence by student');
        }
        const data = await response.json();
        console.log("individual click sequence API", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo click sequence by student:", error);
        throw error;
    }
};

export const fetchQuizCompletionByStudent = async (start, end, courseId) => {
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-completion-by-student`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-completion-by-student`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch quiz completion by student');
        }

        const data = await response.json();
        console.log("individual quiz completion API", data);
        return data;
    } catch (error) {
        console.error("Error fetching quiz completion by student:", error);
        throw error;
    }
};
export const fetchDemoQuizCompletionByStudent = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-question-completion-by-student${query}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo quiz completion by student');
        }
        const data = await response.json();
        console.log("individual quiz completion API", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo quiz completion by student:", error);
        throw error;
    }
}

export const fetchLatestClickByStudent = async (start, end, courseId) => {
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/click-latest-timestamp-by-student-course`;
        } else {
            endpoint = `${BASE_URL}/dashboard/click-latest-timestamp-by-student`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch latest click by student');
        }

        const data = await response.json();
        console.log("individual latest click API", data);
        return data;
    } catch (error) {
        console.error("Error fetching latest click by student:", error);
        throw error;
    }
};
export const fetchDemoLatestClickByStudent = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/click-latest-timestamp-by-student${query}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo latest click by student');
        }
        const data = await response.json();
        console.log("individual latest click API", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo latest click by student:", error);
        throw error;
    }
}

export const fetchCurrentScoresByStudent = async (courseId) => {
    console.log("individualApi - fetchCurrentScoresByStudent - courseId:", courseId);
    try {
        const query = new URLSearchParams({ courseId }).toString();
        const response = await fetch(`${BASE_URL}/dashboard/current-score-by-student?${query}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch current scores by student');
        }

        const data = await response.json();
        console.log("individual current scores API", data);
        return data;

    } catch (error) {
        console.error("Error fetching current scores by student:", error);
        throw error;
    }
};


